import React, { useEffect, useState } from 'react';
import api from '../../services';

const Dashboard = () => {
    const [stats, setStats] = useState({ clients: 0 });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            const response = await api('clients', null, 'GET');
            if (response.status === 200) {
                setStats({ clients: response.data.length });
            }
            setLoading(false);
        };
        fetchStats();
    }, []);

    if (loading) return <div>Loading...</div>;

    return (
        <div>
            <h2>Dashboard</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '24px', marginTop: '24px' }}>
                <div style={{ background: 'white', padding: '24px', borderRadius: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' }}>
                    <h4 style={{ margin: 0, color: '#8c8c8c' }}>Total Clients</h4>
                    <div style={{ fontSize: '32px', fontWeight: 'bold', marginTop: '8px' }}>{stats.clients}</div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
